import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../../../theme/theme.types";

interface AlignmentProps {
  justify?: string;
}

const MainContainer = styled.div<IStyledComponentProps>`
  &.popup-container {
    display: flex;
    font-family: ${(props) => props.theme?.fontFamilies?.regular};
    padding: 6px 10px 4px 0;
    > * + * {
      margin-left: 10px;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      padding: 0;

      .close-button-container {
        margin-left: 0;
      }
    }
  }
`;

const IconContainer = styled.div<IStyledComponentProps & AlignmentProps>`
  align-items: flex-start;
  display: flex;
  justify-content: ${({ justify }) => (justify ? justify : "flex-start")};
  width: 50px;

  &.close-button-container {
    justify-content: flex-end;
  }

  .corner-icon {
    height: 50px;
    margin-top: -6px;
    width: 50px;
  }

  @media (max-width: ${(props) =>
      props.theme.utils.getThemeBreakpoint("tablet")}) {
    .corner-icon {
      margin-top: 0;
    }
  }
`;

const ContentContainer = styled.div<IStyledComponentProps>`
  align-items: flex-start;
  flex: 1;
  margin-left: 10px;
  flex-direction: column;
  .title-container {
    .streetlight-id {
      margin-bottom: 8px;
    }
  }

  .sub-text {
    color: ${({ theme }) => theme.colors?.essential.grayDark};
  }
  .link-button-container {
    padding-bottom: 0;
  }
`;

const ReportedContainer = styled.div<IStyledComponentProps>`
  &.reported-container,
  &.extended-repair-container,
  &.non-ce-container {
    border-top: 1px solid ${({ theme }) => theme.colors?.grays.senary};
    align-items: flex-start;
    flex: 1;
    margin: 12px 10px 4px;
    padding-top: 12px;
    flex-direction: column;
    margin-left: -30px;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      font-family: ${(props) => props.theme.fontFamilies.regular};
      font-size: ${({ theme }) => theme.utils.getFontThemeSize("small")};
      .label {
        padding-right: 12px;
        width: 108px;
        display: inline-block;
      }
    }
  }

  &.reported-container {
    min-height: 100px;
    ul {
      .value {
        color: ${({ theme }) => theme.colors?.alerts.secondary};
        font-family: ${(props) => props.theme.fontFamilies.semiBold};
      }
    }
  }
  &.extended-repair-container {
    min-height: 128px;
    ul {
      .value {
        color: ${({ theme }) => theme.colors?.alerts.primary};
        font-family: ${(props) => props.theme.fontFamilies.semiBold};
      }
    }
    p {
      color: ${({ theme }) => theme.colors?.essential.grayDark};
      margin-top: 12px;
      max-width: 320px;
      font-size: ${({ theme }) => theme.utils.getFontThemeSize("smallest")};
      font-style: italic;
      position: absolute;
      @media (max-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        max-width: 100%;
      }
    }
  }
  &.non-ce-container {
    min-height: 76px;
    p {
      color: ${({ theme }) => theme.colors?.essential.grayDark};
      margin-top: 0px;
      max-width: 300px;
      padding-bottom: 0;
      font-size: ${({ theme }) => theme.utils.getFontThemeSize("smallest")};
      font-style: italic;
      position: absolute;
      @media (max-width: ${(props) =>
          props.theme.utils.getThemeBreakpoint("tablet")}) {
        max-width: 100%;
      }
    }
  }
`;

const CloseButton = styled.button<IStyledComponentProps>`
  background-color: transparent;
  border: 0 none;
  margin-top: 4px;
  padding: 0;
`;

export default {
  CloseButton,
  ContentContainer,
  ReportedContainer,
  IconContainer,
  MainContainer,
};
